const tagMap = {
    utm_source: 'source',
    utm_medium: 'medium',
    utm_campaign: 'campaign',
    utm_term: 'terms',
    utm_content: 'content',
};

export default (params = '') =>
    params
        .replace(/[^a-zA-Z0-9=\-_&]/g, '')
        .split('&')
        .reduce((data, pair) => {
            const keyValue = pair.split('=');

            if (keyValue.length === 2) {
                const [key, value] = keyValue;
                const propKey = tagMap[key];

                if (propKey) {
                    return {
                        ...data,
                        [propKey]: value,
                    };
                }
            }

            return data;
        }, {});



/** WEBPACK FOOTER **
 ** ./src/utils/get-utm-tags.js
 **/